module.exports = __webpack_public_path__ + "img/finish.b51d5e9b.png";